export const time: { label: string; value: number }[] = [];
for (let minutes = 420; minutes <= 1200; minutes += 15) {
  time.push({
    label: `${Math.trunc(minutes / 60)
      .toString()
      .padStart(2, "0")}:${(minutes % 60).toString().padStart(2, "0")}`,
    value: minutes,
  });
}

export const timeSpent = [
  { label: "1min", value: 1 },
  { label: "5min", value: 5 },
  { label: "10min", value: 10 },
  { label: "15min", value: 15 },
  { label: "25min", value: 25 },
  { label: "30min", value: 30 },
  { label: "45min", value: 45 },
  { label: "1h", value: 60 },
  { label: "1h30", value: 90 },
  { label: "2h", value: 120 },
  { label: "3h", value: 180 },
  { label: "4h", value: 240 },
  { label: "5h", value: 300 },
  { label: "6h", value: 360 },
  { label: "7h", value: 420 },
  { label: "8h", value: 480 },
] as const;

export const missedReason = [
  { label: "Absence excusée", value: "absence_excusee" },
  { label: "Absence non excusée", value: "absence_non_excusee" },
] as const;

export const jobSituations = [
  { label: "En emploi", value: "job_ongoing", endOfContract: false, nextFollowUp: true },
  { label: "Fin de contrat", value: "job_finish", endOfContract: true, nextFollowUp: false },
  { label: "Rupture de contrat", value: "contract_breach", endOfContract: true, nextFollowUp: false },
  { label: "Renouvelé", value: "repeated", endOfContract: true, nextFollowUp: false },
  { label: "Inconnu", value: "unknown", endOfContract: false, nextFollowUp: true },
] as const;

export const actionStatus = [
  { label: "Action à réaliser", value: "todo" },
  { label: "Action déjà réalisée", value: "done" },
  { label: "Action manquée", value: "missed" },
] as const;
